export function buildWebsiteJsonLd(pageMetadata) {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "TeammateMe",
    url: "https://www.teammateme.com",
    description:
      pageMetadata?.description ||
      "TeammateMe is a global online platform revolutionizing the process of team building.",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://www.teammateme.com/search?term={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };
}
